exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".font-500[data-v-a812cc32]{font-weight:500}#map-canvas[data-v-a812cc32]{width:100%;height:450px;margin:0 auto}#DeliveryLocation .modal-dialog[data-v-a812cc32]{width:80%}#StockItemModalAdjustQuantity .modal-dialog[data-v-a812cc32],#StockItemModalEdit .modal-dialog[data-v-a812cc32],#StockItemModalReplenish .modal-dialog[data-v-a812cc32],#StockItemModalView .modal-dialog[data-v-a812cc32],#StockItemReceivingModal .modal-dialog[data-v-a812cc32]{min-width:80%}", ""]);

// exports
